import React, { useState } from "react";
import "./auth.css";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import Lock from "@mui/icons-material/Lock";
import LockOpen from "@mui/icons-material/LockOpen";
import PersonOutline from "@mui/icons-material/PersonOutline";
import { styled, makeStyles } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Layout from "../../layout/layout";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
export default function (props) {
  const changeAuthMode = () => {
    props.authModeData("signin");
  };
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setSelectedUserType] = useState("Sales");
  localStorage.setItem("userType", "Sales");
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const LoginButton = styled(Button)(() => ({
    color: "#ffffff",
    fontWeight: 700,
    height: "45px",
    fontSize: "18px",
    borderRadius: 50,
    textTransform: "capitalize",
    background: "linear-gradient(90deg, #061547 0%, #35528E 100%)",
  }));

  const setValue = (value) => {};

  const handleOnChange = (e) => {
    const element = document.getElementById("sliderDiv");
    const style = window.getComputedStyle(element, "::after");

    let value = style.getPropertyValue("content").replace(/"/g, "");
    if (value === "Sale") {
      value = "Sales";
    } else {
      value = "Supply_Chain";
    }
    localStorage.setItem("userType", value);
    setSelectedUserType(value);
  };
  const navigate = useNavigate();

  return (
    <div className="Auth-form-container row w-100 h-100">
      <div className="Auth-form-image borders col h-100 "></div>
      <form className="Auth-form col-5">
        <div className="Auth-form-content m-5">
          <h3 className="Auth-form-title">LOGIN</h3>

          <div className="form-group mt-3">
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel
                htmlFor="standard-adornment-password"
                sx={{
                  fontSize: 18,
                  "&.Mui-focused": { fontSize: 18, color: "#071648" },
                }}
              >
                Email address
              </InputLabel>
              <Input
                id="email"
                type="email"
                sx={{
                  ":before": { borderBottomColor: "#73003B" },
                  // underline when selected
                  ":after": { borderBottomColor: "#73003B" },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility">
                      <PersonOutline
                        fill="#F399C7"
                        style={{ fill: "#F399C7" }}
                      />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="form-group mt-3">
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel
                htmlFor="standard-adornment-password"
                sx={{
                  fontSize: 18,
                  "&.Mui-focused": { fontSize: 18, color: "#071648" },
                }}
              >
                Password
              </InputLabel>
              <Input
                id="password"
                sx={{
                  ":before": { borderBottomColor: "#73003B" },
                  // underline when selected
                  ":after": { borderBottomColor: "#73003B" },
                }}
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? (
                        <LockOpen style={{ fill: "#F399C7" }} />
                      ) : (
                        <Lock style={{ fill: "#F399C7" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <label className="mt-3 fw-bold py-2 d-flex justify-content-center">
                {" "}
                Select Profile
              </label>
              <div
                className="d-flex justify-content-center"
                style={{ pointerEvents: "none" }}
              >
                <label className="switch">
                  <input
                    type="checkbox"
                    id="togBtn"
                    onChange={handleOnChange}
                  />
                  <div className="slider round" id="sliderDiv"></div>
                </label>
              </div>
            </FormControl>
          </div>

          <div className="d-grid gap-2 mt-3">
            <LoginButton
              variant="contained"
              onClick={() => navigate("/select-database")}
              disabled={!userType}
            >
              Login
            </LoginButton>
          </div>

          <div className="forgot-help-div me-1 pe-2 d-none">
            <p className="text-center mt-2">
              <a href="#">Forgot</a>
            </p>{" "}
            <p className="text-center mt-2">
              <a href="#">Help</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}
